export default __webpack_public_path__ + "static/media/play-store-logo.4b82f0bd.png";